import { SearchDateRange } from './SearchDateRange'
import { withSearchDateRange } from './withSearchDateRange'

const ConnectedSearchDateRange = withSearchDateRange(SearchDateRange)
export { ConnectedSearchDateRange as SearchDateRange }
